/* ============================================================
   MUSA · LA MAISON — Interacciones base
   Reveal on scroll (IntersectionObserver) · sin dependencias
   Mejora progresiva: sin JS o en el editor de Shopify, todo visible.
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  /* Marca que el JS está activo: solo entonces el CSS oculta para animar */
  root.classList.add('ms-reveal-on');

  function revealAll(scope) {
    (scope || document).querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('is-inview');
    });
  }

  function initStagger(scope) {
    (scope || document).querySelectorAll('[data-stagger]').forEach(function (parent) {
      var step = parseInt(parent.getAttribute('data-stagger'), 10) || 90;
      Array.prototype.forEach.call(parent.children, function (child, i) {
        if (child.hasAttribute('data-reveal')) {
          child.style.setProperty('--reveal-delay', (i * step) + 'ms');
        }
      });
    });
  }

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-reveal]:not(.is-inview)');
    if (!els.length) return;

    /* En el editor, sin IO, o con reduce-motion: mostrar de inmediato */
    if (reduce || designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-inview'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    els.forEach(function (el) { io.observe(el); });

    /* Red de seguridad: si algo no dispara en 2.5s, revélalo */
    setTimeout(function () { revealAll(scope); }, 2500);
  }

  /* ---- Wishlist (favoritos) · localStorage, sin backend ---- */
  var WL_KEY = 'musa_wishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; } }
  function wlSave(l) { localStorage.setItem(WL_KEY, JSON.stringify(l)); }
  function wlToggle(h) { var l = wlGet(); var i = l.indexOf(h); if (i === -1) { l.push(h); } else { l.splice(i, 1); } wlSave(l); return i === -1; }
  function wlSyncButtons(scope) {
    var l = wlGet();
    (scope || document).querySelectorAll('[data-wish]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-wish')) !== -1;
      b.classList.toggle('is-wished', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function wlSyncCount() {
    var c = wlGet().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = c;
      el.classList.toggle('is-visible', c > 0);
    });
  }
  window.MusaWishlist = { get: wlGet, toggle: wlToggle, save: wlSave };

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    wlToggle(b.getAttribute('data-wish'));
    wlSyncButtons();
    wlSyncCount();
    document.dispatchEvent(new CustomEvent('musa:wishlist:change'));
  });

  function boot(scope) {
    initStagger(scope);
    initReveal(scope);
    wlSyncButtons(scope);
    wlSyncCount();
  }

  /* ---- Carrito: agregar (reutilizable) ---- */
  function cartRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/'; }

  function musaAddToCart(id, qty) {
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty || 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { return res; }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location = cartRoot() + 'cart';
        }
        return res;
      });
  }
  window.MusaCart = { add: musaAddToCart };

  /* Segunda imagen de la tarjeta: se descarga solo al primer hover (solo en
     dispositivos con cursor). En móvil nunca se carga → ahorra ~50% de imágenes. */
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var card = e.target.closest('.mpc');
      if (!card || card.dataset.hoverLoaded) return;
      var back = card.querySelector('.mpc__img--back[data-src]');
      if (!back) { card.dataset.hoverLoaded = '1'; return; }
      card.dataset.hoverLoaded = '1';
      if (back.dataset.srcset) back.setAttribute('srcset', back.dataset.srcset);
      back.setAttribute('src', back.dataset.src);
    }, { passive: true });
  }

  /* Checkout infalible desde el cart drawer/página.
     En la vista previa (dominio *.myshopify.com con reenvío al dominio real)
     usamos _fd=0 para no perder el carrito de la sesión. */
  document.addEventListener('click', function (e) {
    var co = e.target.closest('#CartDrawer-Checkout, .cart__checkout-button');
    if (!co || co.hasAttribute('disabled')) return;
    e.preventDefault();
    var url = cartRoot() + 'checkout';
    if (location.hostname.indexOf('myshopify.com') !== -1) { url += '?_fd=0'; }
    window.location.href = url;
  });

  /* Quick-add desde la tarjeta (delegación) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-add');
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    musaAddToCart(id, 1)
      .then(function () { btn.classList.remove('is-loading'); })
      .catch(function () { btn.classList.remove('is-loading'); window.location = cartRoot() + 'cart'; });
  });

  /* Táctil: primer toque en la foto muestra las tallas; segundo toque (o tocar
     el nombre del producto) entra al producto. Tocar una talla la agrega.
     El scroll fluye porque un desliz no es un tap. */
  if (window.matchMedia('(hover: none)').matches) {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.mpc__link');
      if (link) {
        var frame = link.closest('.mpc__frame');
        var quick = frame && frame.querySelector('.mpc__quick');
        if (quick && !frame.classList.contains('is-quick-open')) {
          e.preventDefault();
          document.querySelectorAll('.mpc__frame.is-quick-open').forEach(function (f) { if (f !== frame) f.classList.remove('is-quick-open'); });
          frame.classList.add('is-quick-open');
          return;
        }
        return; // ya abierto → deja navegar al producto
      }
      if (!e.target.closest('.mpc__frame')) {
        document.querySelectorAll('.mpc__frame.is-quick-open').forEach(function (f) { f.classList.remove('is-quick-open'); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Editor de temas: al recargar/añadir una sección, re-inicializa y revela */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
    if (designMode) revealAll(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    revealAll(e.target);
  });
})();
